// import FacebookIcon from '~icons/knowz-iconify/facebook-rounded'; //TODO: Uncomment when ready
// import InstagramIcon from '~icons/knowz-iconify/instagram-square';  //TODO: Uncomment when ready
// import LinkedInIcon from '~icons/knowz-iconify/linkedin-square'; //TODO: Uncomment when ready
import LighteningRoundedIcon from '~icons/knowz-iconify/lightening-rounded';

const SOCIALS = [
  // { //TODO: Uncomment when ready
  //   title: 'Facebook',
  //   href: 'https://www.facebook.com/knowzit',
  //   icon: <FacebookIcon fontSize="0.8em" />,
  // },
  {
    mappedLabel: 'layout.toolbar.buttons.followUs',
    defaultLabel: 'Follow knowz for secrets',
    href: 'https://www.instagram.com/knowzai',
    icon: <LighteningRoundedIcon fontSize="1.5em" />,
  },
  // { //TODO: Uncomment when ready
  //   title: 'LinkedIn',
  //   href: 'https://www.linkedin.com/company/knowzsearch',
  //   icon: <LinkedInIcon fontSize="0.8em" />,
  // },
];

export default SOCIALS;
